export default __webpack_public_path__ + "static/media/stuartquan.b425e57f.jpg";